import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyInfo } from '../models/currency-info';
import { formatCashDollarAmount } from '../models/player-balance';

@Pipe({ name: 'cashDollar' })
export class CashDollarPipe implements PipeTransform {
    transform(value: number, currency: CurrencyInfo, amountOnly?: boolean): string {
        return formatCashDollarAmount(value, currency, !!amountOnly);
    }
}
